import React, { useState, useEffect, useRef } from 'react';
import ProxyImage from './ProxyImage';
interface MoodLogoWithTooltipProps {
  isDarkMode: boolean;
  className: string;
}
const MoodLogoWithTooltip: React.FC<MoodLogoWithTooltipProps> = ({ isDarkMode, className }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState<{ left: number; top: number } | null>(null);
  const tooltipRef = useRef<HTMLDivElement | null>(null);
  const linkRef = useRef<HTMLAnchorElement | null>(null);
  const email = 'contacto@mood-producciones.com';
  // Efecto para manejar el tooltip en el DOM
  useEffect(() => {
    // Limpiar tooltip existente primero
    if (tooltipRef.current && tooltipRef.current.parentNode) {
      tooltipRef.current.parentNode.removeChild(tooltipRef.current);
      tooltipRef.current = null;
    }
    if (showTooltip && tooltipPosition !== null) {
      // Detectar si está en modo oscuro
      const isDark = document.documentElement.classList.contains('dark-theme');
      const tooltipDiv = document.createElement('div');
      tooltipDiv.className = 'tooltip-content';
      tooltipDiv.style.cssText = `
        position: fixed !important;
        left: ${tooltipPosition.left}px !important;
        top: ${tooltipPosition.top}px !important;
        z-index: 999999 !important;
        background-color: ${isDark ? '#0f172a' : '#ffffff'} !important;
        border: 2px solid #CE2B15 !important;
        border-radius: 8px !important;
        padding: 12px 16px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        width: fit-content !important;
        min-width: auto !important;
        max-width: none !important;
        white-space: nowrap !important;
        font-family: Montserrat, sans-serif !important;
        pointer-events: none !important;
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
      `;
      const textDiv = document.createElement('div');
      textDiv.style.cssText = `font-size: 13px; color: ${isDark ? '#f1f5f9' : '#1e293b'}; line-height: 1.5; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;`;
      textDiv.textContent = email;
      tooltipDiv.appendChild(textDiv);
      if (document.body) {
        document.body.appendChild(tooltipDiv);
        tooltipRef.current = tooltipDiv;
      }
      return () => {
        if (tooltipRef.current && tooltipRef.current.parentNode) {
          tooltipRef.current.parentNode.removeChild(tooltipRef.current);
        }
        tooltipRef.current = null;
      };
    }
  }, [showTooltip, tooltipPosition]);
  const handleMouseEnter = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!linkRef.current) return;
    const rect = linkRef.current.getBoundingClientRect();
    // Calcular el ancho necesario para el correo (aproximadamente 280px para "contacto@mood-producciones.com")
    const tooltipWidth = 280;
    const spacing = 10;
    let left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
    let top = rect.bottom + spacing;
    // Ajustar si se sale de la pantalla
    if (left + tooltipWidth > window.innerWidth) {
      left = window.innerWidth - tooltipWidth - 10;
    }
    if (left < 10) {
      left = 10;
    }
    const tooltipHeight = 50;
    if (top + tooltipHeight > window.innerHeight) {
      top = rect.top - tooltipHeight - spacing;
    }
    if (top < 10) {
      top = 10;
    }
    setTooltipPosition({ left, top });
    setShowTooltip(true);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
    setTooltipPosition(null);
  };
  return (
    <a
      ref={linkRef}
      href={`mailto:${email}`}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ProxyImage
        src={isDarkMode 
          ? 'https://smartcityexposantiagodelestero.com/wp-content/uploads/2026/01/logo-nuevo-mood-final-white-e1768878283989.png'
          : 'https://smartcityexposantiagodelestero.com/wp-content/uploads/2026/01/logo-mood-color-e1768878022934.png'
        }
        alt="Mood Producciones"
        style={{
          height: isDarkMode ? '28px' : '32px',
          maxWidth: isDarkMode ? '100px' : '120px',
          width: 'auto',
          objectFit: 'contain'
        }}
      />
    </a>
  );
};
export default MoodLogoWithTooltip;